import { Link } from 'react-router-dom';
import type { CommitteeMember } from '../types/api.types';
import type { MemberLookupFn } from '../utils/committee';

interface CommitteeHistoryTableProps {
  committeeMembers: CommitteeMember[];
  memberLookup: MemberLookupFn;
}

// Component for rendering a committee member cell with link
const CommitteeMemberCell = ({
  memberId,
  memberLookup,
}: {
  memberId: string | null | undefined;
  memberLookup: MemberLookupFn;
}) => {
  if (!memberId) return <td style={{ padding: '12px' }}>-</td>;

  return (
    <td style={{ padding: '12px' }}>
      <Link to={`/members/${memberId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        {memberLookup(memberId)}
      </Link>
    </td>
  );
};

// Component for table header
const TableHeader = () => (
  <thead>
    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Season</th>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Chairman</th>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Captain</th>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Secretary</th>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Treasurer</th>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Committee Member 1</th>
      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Committee Member 2</th>
    </tr>
  </thead>
);

// Component for a single committee row
const CommitteeRow = ({
  committee,
  index,
  memberLookup,
}: {
  committee: CommitteeMember;
  index: number;
  memberLookup: MemberLookupFn;
}) => (
  <tr
    style={{
      borderBottom: '1px solid #dee2e6',
      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
    }}
  >
    <td style={{ padding: '12px', fontWeight: 'bold' }}>{committee.season}</td>
    <CommitteeMemberCell memberId={committee.chairman} memberLookup={memberLookup} />
    <CommitteeMemberCell memberId={committee.captain} memberLookup={memberLookup} />
    <CommitteeMemberCell memberId={committee.secretary} memberLookup={memberLookup} />
    <CommitteeMemberCell memberId={committee.treasurer} memberLookup={memberLookup} />
    <CommitteeMemberCell memberId={committee.committeeMember1} memberLookup={memberLookup} />
    <CommitteeMemberCell memberId={committee.committeeMember2} memberLookup={memberLookup} />
  </tr>
);

export default function CommitteeHistoryTable({ committeeMembers, memberLookup }: CommitteeHistoryTableProps) {
  return (
    <div className="aboutpage">
      <div style={{ overflowX: 'auto' }}>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
            fontSize: '14px',
          }}
        >
          <TableHeader />
          <tbody>
            {committeeMembers
              .slice()
              .reverse()
              .map((committee, index) => (
                <CommitteeRow key={committee.season} committee={committee} index={index} memberLookup={memberLookup} />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
